import React, { useEffect, useState, useRef } from 'react';
import Cardsimple from '../../cards/Cardsimple';
import UploaderImagen from './UploaderImagen';

const GaleriaImagenes = ({ codigo }) => {
    const [imagenes, setImagenes] = useState([]);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [indiceSeleccionado, setIndiceSeleccionado] = useState(null);
    const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
    const [imagenAEliminar, setImagenAEliminar] = useState(null);

    const startX = useRef(null);

    useEffect(() => {
        cargarImagenes();
    }, [codigo]);

    useEffect(() => {
        const manejarTecla = (e) => {
            if (!mostrarModal) return;
            if (e.key === 'ArrowLeft') anterior();
            if (e.key === 'ArrowRight') siguiente();
            if (e.key === 'Escape') cerrarModal();
        };

        window.addEventListener('keydown', manejarTecla);
        return () => window.removeEventListener('keydown', manejarTecla);
    }, [mostrarModal, indiceSeleccionado, imagenes]);

    const cargarImagenes = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_URL_API}imagen/listar/${codigo}`);
            const data = await res.json();
            setImagenes(data);
        } catch (err) {
            console.error('Error al cargar imágenes:', err);
        }
    };

    const imagenSeleccionada = indiceSeleccionado !== null ? imagenes[indiceSeleccionado] : null;

    const eliminarImagen = async (id) => {

        try {
            const res = await fetch(`${process.env.REACT_APP_URL_API}imagen/eliminar/${id}`, {
                method: 'DELETE',
            });
            const result = await res.json();
            if (result.resultado === 1) {
                const nuevasImagenes = imagenes.filter(img => img.idimagen !== id);
                setImagenes(nuevasImagenes);

                if (nuevasImagenes.length === 0) {
                    setTimeout(cerrarModal, 300); // Cierra con retardo
                } else if (indiceSeleccionado >= nuevasImagenes.length) {
                    setIndiceSeleccionado(nuevasImagenes.length - 1);
                } else {
                    setIndiceSeleccionado(indiceSeleccionado);
                }
            } else {
                alert(result.mensaje || 'No se pudo eliminar la imagen.');
            }
        } catch (err) {
            alert('Error al eliminar la imagen.');
        }
    };

    const establecerPrincipal = async (id) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_URL_API}imagen/establecer-principal/${id}`, {
                method: 'POST',
            });
            const result = await res.json();
            if (result.resultado === 1) {
                cargarImagenes();
                cerrarModal(); // 👈 cerrar después de marcar
            } else {
                alert(result.mensaje || 'No se pudo establecer como principal.');
            }
        } catch (err) {
            alert('Error al actualizar la imagen.');
        }
    };


    const obtenerImagenPrincipal = () => {
        if (imagenes.length === 0) return null;
        const principal = imagenes.find(img => Number(img.principal) === 1);
        return principal || imagenes[0];
    };


    const abrirModal = (indice) => {
        setIndiceSeleccionado(indice);
        setMostrarModal(true);
    };

    const cerrarModal = () => {
        setMostrarModal(false);
        setIndiceSeleccionado(null);
    };

    const siguiente = () => {
        if (indiceSeleccionado < imagenes.length - 1) {
            setIndiceSeleccionado(indiceSeleccionado + 1);
        }
    };

    const anterior = () => {
        if (indiceSeleccionado > 0) {
            setIndiceSeleccionado(indiceSeleccionado - 1);
        }
    };

    const handleTouchStart = (e) => {
        startX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        if (startX.current === null) return;
        const endX = e.changedTouches[0].clientX;
        const deltaX = endX - startX.current;

        if (deltaX > 50) anterior(); // Swipe derecha
        if (deltaX < -50) siguiente(); // Swipe izquierda

        startX.current = null;
    };

    const confirmarEliminacion = (imagen) => {
        setImagenAEliminar(imagen);
        setMostrarConfirmacion(true);
    };


    return (
        <Cardsimple header={<h5 className="text-sm text-center my-0">🖼️ Galería de imágenes</h5>}
            style={`card card-info shadow text-center`} >
            <div className="">

                {imagenes.length === 0 && <p className="text-muted">No hay imágenes subidas.</p>}

                {/* Imagen principal destacada con fondo difuminado */}
                {obtenerImagenPrincipal() && (
                    <div className="mb-4">
                        <img
                            src={`${process.env.REACT_APP_URL_IMG}/mediano/${obtenerImagenPrincipal().nombre}`}
                            alt="Imagen principal"
                            className="img-fluid rounded img-thumbnail"
                            style={{ maxHeight: '400px', objectFit: 'contain', cursor: 'pointer' }}
                            onClick={() => {
                                const idx = imagenes.findIndex(img => img.idimagen === obtenerImagenPrincipal().idimagen);
                                if (idx !== -1) abrirModal(idx);
                            }}
                        />
                        <p className="mt-1 text-secondary small">
                            <strong>Imagen principal</strong> {obtenerImagenPrincipal().detalle}
                        </p>
                    </div>
                )}

                <div className="d-flex flex-wrap">
                    {imagenes.map((img, i) => (
                        <div key={img.idimagen} className="position-relative m-1 ">
                            <img
                                src={`${process.env.REACT_APP_URL_IMG}/miniatura/${img.nombre}`}
                                alt={img.detalle}
                                className="img-thumbnail"
                                style={{ width: '50px', height: '50px', objectFit: 'cover', cursor: 'pointer' }}
                                onClick={() => abrirModal(i)}
                            />
                            {img.principal === "1" && (
                                <span className="badge badge-success position-absolute" style={{ top: '5px', right: '5px' }}>
                                    ⭐
                                </span>
                            )}
                        </div>
                    ))}
                </div>

                {mostrarModal && imagenSeleccionada && (
                    <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                        onClick={cerrarModal}
                    >
                        <div
                            className="modal-dialog modal-lg modal-dialog-centered"
                            role="document"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Vista previa</h5>
                                    <button type="button" className="close" onClick={cerrarModal}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div
                                    className="modal-body text-center position-relative"
                                    style={{ maxHeight: '90vh', overflowY: 'auto' }}
                                    onTouchStart={handleTouchStart}
                                    onTouchEnd={handleTouchEnd}
                                >
                                    {/* Flechas flotantes */}
                                    <button
                                        onClick={anterior}
                                        disabled={indiceSeleccionado === 0}
                                        className="btn btn-light position-absolute"
                                        style={{
                                            top: '50%',
                                            left: '10px',
                                            transform: 'translateY(-50%)',
                                            fontSize: '2rem',
                                            zIndex: 10,
                                            opacity: indiceSeleccionado === 0 ? 0.5 : 1,
                                        }}
                                    >
                                        ‹
                                    </button>
                                    <button
                                        onClick={siguiente}
                                        disabled={indiceSeleccionado === imagenes.length - 1}
                                        className="btn btn-light position-absolute"
                                        style={{
                                            top: '50%',
                                            right: '10px',
                                            transform: 'translateY(-50%)',
                                            fontSize: '2rem',
                                            zIndex: 10,
                                            opacity: indiceSeleccionado === imagenes.length - 1 ? 0.5 : 1,
                                        }}
                                    >
                                        ›
                                    </button>

                                    {/* Imagen ampliada */}
                                    <div
                                        className="position-relative"
                                        style={{
                                            height: '60vh',
                                            overflow: 'hidden',
                                            backgroundColor: '#000',
                                        }}
                                    >
                                        {/* Fondo difuminado */}
                                        <img
                                            src={`${process.env.REACT_APP_URL_IMG}/mediano/${imagenSeleccionada.nombre}`}
                                            alt="blur-bg"
                                            className="position-absolute w-100 h-100"
                                            style={{
                                                objectFit: 'cover',
                                                filter: 'blur(20px)',
                                                top: 0,
                                                left: 0,
                                                zIndex: 1,
                                            }}
                                        />

                                        {/* Imagen centrada principal */}
                                        <div
                                            className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                                            style={{ zIndex: 2 }}
                                        >
                                            <img
                                                src={`${process.env.REACT_APP_URL_IMG}/mediano/${imagenSeleccionada.nombre}`}
                                                alt="vista ampliada"
                                                className="img-fluid"
                                                style={{
                                                    maxHeight: '100%',
                                                    maxWidth: '100%',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="text-muted">
                                        <strong>Fecha subida:</strong>{" "}
                                        {new Date(imagenSeleccionada.fecha_registro).toLocaleString("es-PE", {
                                            day: "2-digit",
                                            month: "long",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit"
                                        })}
                                    </div>
                                    <div>
                                        Imagen {indiceSeleccionado + 1} de {imagenes.length}
                                    </div>
                                </div>
                                <div className="modal-footer justify-content-between">
                                    <button
                                        className="btn btn-xs btn-outline-danger"
                                        onClick={() => confirmarEliminacion(imagenSeleccionada)}
                                        title="Eliminar esta imagen permanentemente"
                                    >
                                        🗑 Eliminar
                                    </button>


                                    <div className="d-flex">
                                        <button
                                            className="btn btn-success btn-sm mr-2"
                                            onClick={() => establecerPrincipal(imagenSeleccionada.idimagen)}
                                            disabled={imagenSeleccionada.principal === 1}
                                        >
                                            ⭐ Establecer como Principal
                                        </button>
                                        <button className="btn btn-secondary btn-sm" onClick={cerrarModal}>
                                            Cerrar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <UploaderImagen
                codigo={codigo}
                tipo_imagen="equipo"
                detalle=""
                onUploadSuccess={cargarImagenes}
            />


            {mostrarConfirmacion && imagenAEliminar && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title text-danger">Confirmar eliminación</h5>
                                <button type="button" className="close" onClick={() => setMostrarConfirmacion(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body text-center">
                                <p>¿Estás seguro que deseas eliminar esta imagen?</p>
                                <img
                                    src={`${process.env.REACT_APP_URL_IMG}/miniatura/${imagenAEliminar.nombre}`}
                                    alt="mini"
                                    className="img-thumbnail"
                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                                <p className="mt-2 text-muted"><strong>{imagenAEliminar.detalle}</strong></p>
                            </div>
                            <div className="modal-footer justify-content-between">
                                <button className="btn btn-secondary" onClick={() => setMostrarConfirmacion(false)}>
                                    Cancelar
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => {
                                        eliminarImagen(imagenAEliminar.idimagen);
                                        setMostrarConfirmacion(false);
                                    }}
                                >
                                    Sí, eliminar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </Cardsimple>




    );
};

export default GaleriaImagenes;
